/** @deprecated */
import _cloneDeep from 'lodash.clonedeep';

export function cloneDeep(obj) {
  return _cloneDeep(obj);
}